<template>

    
        <BFormGroup class="col-md-6 pb-4 pt-4 " id="prepay-input-group " label="Відсоток предоплати">
            <BFormInput type="number" v-model="pay_prepay"></BFormInput>
        </BFormGroup>
        
        <BFormGroup class="col-md-6 pb-4 pt-4 " id="prepaydescription-input-group" label="Опис предоплати">
            <BFormInput v-model="payment.prepay_description"></BFormInput>
        </BFormGroup>
        
        <BFormGroup class="col-md-6 pb-4" id="prepaydescription-input-group" label="Відсоток відстрочки">
            {{ postpay }}%
        </BFormGroup>
        
        <BFormGroup v-if="postpay" class="col-md-6 pb-4" id="postpaydescription-input-group" label="Опис відстрочки">
            <BFormInput v-model="payment.postpay_description"></BFormInput>
        </BFormGroup>
        
        <BFormGroup v-if="postpay" class="col-md-6 pb-4 pt-1" id="postday-input-group" label="Днів відстрочки">
            <BFormInput v-model="payment.postday"></BFormInput>
        </BFormGroup>
        
        <BFormGroup v-if="postpay" class="col-md-6 pb-4" id="postperiod-input-group" label="Оплата відстрочки">
            <v-select
                label="text"
                :options="postperiods"
                v-model="payment.postperiod"
                :reduce="postperiod => postperiod.value"
            ></v-select>
        </BFormGroup>
    

</template>

<script>

import vSelect from 'vue-select';
import {
    BForm,
    BFormGroup,
    BFormInput,
} from 'bootstrap-vue-next';


export default {
    name: "payment",
    components : {
        vSelect,
        BFormGroup,
        BFormInput
    },
    
    props : {
        payment : {
            type : Object
        }
    },
    
    data() {
        return {
            postperiods: [
                {"value": "0", "text": "В кінці строку"},
                {"value": "1", "text": "щомісяця рівними частинами"},
                {"value": "2", "text": "щотижня рівними частинами"}
            ],
            
            
        }
    },
    
    methods: {
        
        chk100(val) {
            if (val > 100 || val < 0 || val == '') {
                this.payment.prepay = 100
            }
        }
    },
    
    computed: {
        
        postpay: function () {
            return 100 - this.payment.prepay
        },
        
        pay_prepay: {
            get: function () {
                return this.payment.prepay;
            },
            set: function (newValue) {
                
                if (parseInt(newValue) < 0 || parseInt(newValue) > 100) {
                    this.payment.prepay = 100;
                } else {
                    this.payment.prepay = newValue;
                }
                
            },
        }
    },
    
    
}

</script>


